
(function ($) {
    // - validador fecha
    $.validator.addMethod("dateFormat", function (value, element) {
        var valid = false;
        try {
            var pattern = /^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{4})/;
            var match = pattern.exec(value);
            var date = new Date(Date.UTC(match[3], (match[2] - 1), match[1]));

            if (date.getFullYear() == match[3] && date.getMonth() == (match[2] - 1) && date.getDate() == match[1]) {
                valid = true;
            }
        } catch (error) {
            valid = false;
        }


        return this.optional(element) || valid;
    }, "Fecha incorrecta");

    // - validador nif
    $.validator.addMethod("nifES", function (value, element) {
        "use strict";

        if (this.optional(element)) {
            return true;
        }

        value = value.toUpperCase();

        // Basic format test
        if (!value.match("((^[A-Z]{1}[0-9]{7}[A-Z0-9]{1}$|^[T]{1}[A-Z0-9]{8}$)|^[0-9]{8}[A-Z]{1}$)")) {
            return false;
        }

        // Test NIF
        if (/^[0-9]{8}[A-Z]{1}$/.test(value)) {
            return ("TRWAGMYFPDXBNJZSQVHLCKE".charAt(value.substring(8, 0) % 23) === value.charAt(8));
        }

        // Test specials NIF (starts with K, L or M)
        if (/^[KLM]{1}/.test(value)) {
            return (value[8] === "TRWAGMYFPDXBNJZSQVHLCKE".charAt(value.substring(8, 1) % 23));
        }

        return false;

    }, "Por favor, indique un NIF válido.");

    // - validador NIE
    $.validator.addMethod("nieES", function (value, element) {
        "use strict";

        if (this.optional(element)) {
            return true;
        }

        var nieRegEx = new RegExp(/^[MXYZ]{1}[0-9]{7,8}[TRWAGMYFPDXBNJZSQVHLCKET]{1}$/gi);
        var validChars = "TRWAGMYFPDXBNJZSQVHLCKET",
            letter = value.substr(value.length - 1).toUpperCase(),
            number;

        value = value.toString().toUpperCase();

        // Quick format test
        if (value.length > 10 || value.length < 9 || !nieRegEx.test(value)) {
            return false;
        }

        // X means same number
        // Y means number + 10000000
        // Z means number + 20000000
        value = value.replace(/^[X]/, "0")
            .replace(/^[Y]/, "1")
            .replace(/^[Z]/, "2");

        number = value.length === 9 ? value.substr(0, 8) : value.substr(0, 9);

        return validChars.charAt(parseInt(number, 10) % 23) === letter;

    }, "Por favor, indique un NIE válido.");

    // - validador pasaporte
    $.validator.addMethod('pasaporte', function (value, element) {
        return this.optional(element) || /^[a-z]{3}[0-9]{6}[a-z]?$/i.test(value);
    }, "Por favor, indique un pasaporte válido.");

    // - validador CIF
    $.validator.addMethod("document_CIF", function (value, element) {
        "use strict";

        if (this.optional(element)) {
            return true;
        }

        var cifRegEx = new RegExp(/^([ABCDEFGHJKLMNPQRSUVW])(\d{7})([0-9A-J])$/gi);
        var letter = value.substring(0, 1), // [ T ]
            number = value.substring(1, 8), // [ P ][ P ][ N ][ N ][ N ][ N ][ N ]
            control = value.substring(8, 9), // [ C ]
            all_sum = 0,
            even_sum = 0,
            odd_sum = 0,
            i, n,
            control_digit,
            control_letter;

        function isOdd(n) {
            return n % 2 === 0;
        }

        // Quick format test
        if (value.length !== 9 || !cifRegEx.test(value)) {
            return false;
        }

        for (i = 0; i < number.length; i++) {
            n = parseInt(number[i], 10);

            // Odd positions
            if (isOdd(i)) {

                // Odd positions are multiplied first.
                n *= 2;

                // If the multiplication is bigger than 10 we need to adjust
                odd_sum += n < 10 ? n : n - 9;

                // Even positions
                // Just sum them
            } else {
                even_sum += n;
            }
        }

        all_sum = even_sum + odd_sum;
        control_digit = (10 - (all_sum).toString().substr(-1)).toString();
        control_digit = parseInt(control_digit, 10) > 9 ? "0" : control_digit;
        control_letter = "JABCDEFGHI".substr(control_digit, 1).toString();

        // Control must be a digit
        if (letter.match(/[ABEH]/)) {
            return control === control_digit;

            // Control must be a letter
        } else if (letter.match(/[KPQS]/)) {
            return control === control_letter;
        }

        // Can be either
        return control === control_digit || control === control_letter;

    }, "Por favor, indique un CIF válido.");

    // - validador pattern
    $.validator.addMethod("pattern", function (value, element, param) {
        if (this.optional(element)) {
            return true;
        }
        if (typeof param === "string") {
            param = new RegExp("^(?:" + param + ")$");
        }
        return param.test(value);
    }, "Formato no válido.");

    // - tipo de documento
    $.validator.addMethod("documentType", function (value, element, params) {
        var type = params[0];
        var document = params[1];
        var result;
        switch (type) {
            case 'NIE':
                result = $.validator.methods.nieES.call(this, document, element);
                break;
            case 'NIF':
                result = $.validator.methods.nifES.call(this, document, element);
                break;
            case 'PASSPORT':
                result = $.validator.methods.pasaporte.call(this, document, element);
                break;
            case 'CIF':
                result = $.validator.methods.document_CIF.call(this, document, element);
                break;
            default:
                result = true;
                break;
        }

        return result;
    }, 'Por favor, indique un documento válido.');
})(jQuery);